document.addEventListener('DOMContentLoaded', function () {
  const getFormId = () => {
    const firstRadio = document.querySelector('input[type="radio"][form^="product-form-template"]');
    return firstRadio ? firstRadio.getAttribute('form') : null;
  };

  function filterImages(selectedValue) {
    if (!selectedValue) return;
    const val = selectedValue.trim().toLowerCase();

    const thumbItems = document.querySelectorAll('.thumbnail-list__item');
    const mediaItems = document.querySelectorAll('.product__media-item');

    // Check if any thumbnails match the selection
    const anyMatches = Array.from(thumbItems).some(item => {
      const img = item.querySelector('img');
      return (img?.alt || '').trim().toLowerCase().includes(val);
    });

    // If no matches are found, we don't filter (prevents hiding everything on size changes, etc.)
    if (!anyMatches) return;

    // Filter Thumbnails
    thumbItems.forEach(item => {
      const img = item.querySelector('img');
      const alt = (img?.alt || '').trim().toLowerCase();
      item.style.display = alt.includes(val) ? '' : 'none';
    });

    // Filter Main Media items (the actual slider/main images)
    mediaItems.forEach(item => {
      const img = item.querySelector('img');
      const alt = (img?.alt || '').trim().toLowerCase();
      item.style.display = alt.includes(val) ? '' : 'none';
    });

    // Fix: Update the main image by clicking the first visible thumbnail
    const firstVisibleThumb = Array.from(thumbItems).find(item => item.style.display !== 'none');
    if (firstVisibleThumb) {
      const trigger = firstVisibleThumb.querySelector('button, a, img');
      if (trigger) trigger.click();
    }
    
    // Dawn-specific slider refresh if applicable
    const slider = document.querySelector('slider-component');
    if (slider && typeof slider.initPages === 'function') slider.initPages();
  }

  // Use event delegation to handle radio buttons, even if re-rendered by Shopify
  document.addEventListener('change', function (event) {
    const target = event.target;
    const formId = getFormId();
    
    if (target.matches('input[type="radio"]')) {
      const nameAttr = (target.getAttribute('name') || '').toLowerCase();
      const fieldset = target.closest('fieldset');
      const legendText = fieldset ? (fieldset.querySelector('legend')?.textContent || '').toLowerCase() : '';
      
      // Only proceed if the variant option is "Chocolate"
      if (nameAttr.includes('chocolate') || legendText.includes('chocolate')) {
        const val = target.value;
        // Wait slightly for Shopify's own state changes
        setTimeout(() => filterImages(val), 50);
        setTimeout(() => filterImages(val), 250);
      }
    }
  });

  // Initial run for the default selected variant
  const formId = getFormId();
  if (formId) {
    const checkedRadio = document.querySelector(`input[type="radio"][form="${formId}"]:checked`);
    if (checkedRadio) {
      const nameAttr = (checkedRadio.getAttribute('name') || '').toLowerCase();
      const fieldset = checkedRadio.closest('fieldset');
      const legendText = fieldset ? (fieldset.querySelector('legend')?.textContent || '').toLowerCase() : '';
      
      if (nameAttr.includes('chocolate') || legendText.includes('chocolate')) {
        setTimeout(() => filterImages(checkedRadio.value), 100);
      }
    }
  }
});